const faqItems = [
  {
    q: '7777影院需要注册才能观看吗？',
    a: '不需要。7777影院完全免费开放，无需注册、登录或任何会员操作，打开网站即可直接搜索和播放你想看的所有内容，真正做到即点即播。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '7777影院全面适配电脑、平板和手机端，支持高清1080P和超清4K画质。平台采用智能码率自适应技术，根据你的网络环境自动匹配最佳清晰度，确保流畅不卡顿。',
  },
  {
    q: '资源更新速度快吗？新片多久上线？',
    a: '非常快。7777影院的资源团队每日凌晨同步全网片源，院线电影下线后通常在24-48小时内上线高清版本，热播剧集实现与卫视同步日更，追剧不用等。',
  },
  {
    q: '播放卡顿怎么办？有哪些线路可选？',
    a: '每部影片均配备多条播放线路（通常3-6条），如遇卡顿可直接切换其他线路继续观看。建议优先选择标注"极速"或"优选"的线路节点，体验更佳。',
  },
  {
    q: '网站有没有广告或弹窗？安全性如何？',
    a: '7777影院采用纯净观影模式，播放页面无弹窗广告、无强制跳转，并启用HTTPS全站加密传输。我们坚决不做恶意软件捆绑，保障你的设备和隐私安全。',
  },
  {
    q: '可以下载影片离线观看吗？',
    a: '平台主要提供在线播放服务。部分资源标注有下载入口，可通过第三方下载工具获取。我们建议使用在线观看以获得最佳体验，同时也支持APP端缓存部分内容。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap mb-3">
            常见问答
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于7777影院的常见问题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">快速了解平台使用方式，观影无忧</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}